import { S3Client, PutObjectCommand, GetObjectCommand, DeleteObjectCommand } from "@aws-sdk/client-s3";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";

const R2_ACCESS_KEY_ID = import.meta.env.VITE_R2_ACCESS_KEY_ID;
const R2_SECRET_ACCESS_KEY = import.meta.env.VITE_R2_SECRET_ACCESS_KEY;
let R2_ENDPOINT = import.meta.env.VITE_R2_ENDPOINT || '';
if (R2_ENDPOINT.startsWith('ttps://')) {
  R2_ENDPOINT = 'h' + R2_ENDPOINT;
} else if (R2_ENDPOINT && !R2_ENDPOINT.startsWith('http')) {
  R2_ENDPOINT = 'https://' + R2_ENDPOINT;
}
const R2_BUCKET_NAME = import.meta.env.VITE_R2_BUCKET_NAME;

const s3Client = new S3Client({
  region: "auto",
  endpoint: R2_ENDPOINT,
  credentials: {
    accessKeyId: R2_ACCESS_KEY_ID,
    secretAccessKey: R2_SECRET_ACCESS_KEY,
  },
});

/**
 * Cloudflare R2 Storage Wrapper
 * Compatible with basic Supabase Storage signatures
 */
export const r2Storage = {
  from: (bucketName) => {
    return {
      upload: async (path, file) => {
        try {
          const command = new PutObjectCommand({
            Bucket: R2_BUCKET_NAME,
            Key: path,
            Body: file,
            ContentType: file.type,
          });
          await s3Client.send(command);
          return { data: { path }, error: null };
        } catch (error) {
          console.error('R2 upload error:', error);
          return { data: null, error };
        }
      },
      
      createSignedUrl: async (path, expiresIn = 3600) => {
        try {
          let workerUrl = import.meta.env.VITE_WORKER_URL || '';
          if (workerUrl) {
            if (workerUrl.startsWith('ttps://')) workerUrl = 'h' + workerUrl;
            if (!workerUrl.startsWith('http')) workerUrl = 'https://' + workerUrl;
            // Provide the public worker proxy read URL instead of AWS presigned URL
            return { data: { signedUrl: `${workerUrl}/read/${path}` }, error: null };
          }
          
          const command = new GetObjectCommand({
            Bucket: R2_BUCKET_NAME,
            Key: path,
          });
          const signedUrl = await getSignedUrl(s3Client, command, { expiresIn });
          return { data: { signedUrl }, error: null };
        } catch (error) {
          console.error('R2 signed URL error:', error);
          return { data: null, error };
        }
      },
      
      remove: async (paths) => {
        try {
          let workerUrl = import.meta.env.VITE_WORKER_URL || '';
          if (workerUrl) {
            if (workerUrl.startsWith('ttps://')) workerUrl = 'h' + workerUrl;
            if (!workerUrl.startsWith('http')) workerUrl = 'https://' + workerUrl;
            const workerSecret = import.meta.env.VITE_WORKER_SECRET;

            await Promise.all(paths.map(async (path) => {
              const res = await fetch(`${workerUrl}/delete/${path}`, {
                method: 'DELETE',
                headers: { 'X-Worker-Auth': workerSecret }
              });
              if (!res.ok) throw new Error('Proxy delete failed');
            }));
            return { data: paths, error: null };
          }

          // Promise.all to handle multiple paths if needed
          await Promise.all(paths.map(path => 
            s3Client.send(new DeleteObjectCommand({
              Bucket: R2_BUCKET_NAME,
              Key: path,
            }))
          ));
          return { data: paths, error: null };
        } catch (error) {
          console.error('R2 remove error:', error);
          return { data: null, error };
        }
      }
    };
  }
};
